import type { defaultPassengerData, documentTypes } from './config';

export type PassengerData = typeof defaultPassengerData & {
  id: string;
  account: string;
  direction: 'airflow' | 'rwflow';
  __internalFormIdx__?: number;
};

type DocumentTypesKeys = keyof typeof documentTypes;
export type DocumentType = (typeof documentTypes)[DocumentTypesKeys];

export enum FareType {
  ADULT = '0',
  CHILD = '1',
}

export enum Gender {
  M = '0',
  F = '1',
}
